<template>
  <nav class="nav_bar" :class="{startIcon:getNavIcon, icon:getNavIcon}" v-scroll="handleScroll" @mouseenter.capture="openNavMain" @mouseleave.capture="closeNavMain" ref="nav" aria-label="グローバルナビゲーション">
    <router-link class="navbar-brand" to="/">豊嶋精密工業株式会社</router-link>
    <button class="navbar-toggler" type="button" @click="mainMenu" role="button" aria-label="ナビゲーション表示ボタン">
      <span class="navbar-toggler-icon"></span>
    </button>
    <ul class="nav_main" @click="mainMenu">
      <li class="">
				<router-link class="linkHome" to="/" :class="{linkDisable:true, linkEnable:linkStatus}" active-class="pageActive" exact><img src="/asset/images/components/nav/homeIcon.svg" alt="home"></router-link>
			</li>
      <li class="">
        <router-link class="" to="/policy" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>会社方針
        </router-link>
      </li>
      <li class="">
        <router-link class="withSubMenu" to="/business" @mouseenter.native="openSubMenu" @mouseleave.native="closeSubMenu" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>業務内容
          <ul class="subMenu">
            <li class=""><router-link class="" to="/business/equipment?list=1" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>設備一覧</router-link></li>
            <li class=""><router-link class="" to="/business/material?list=1" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>取扱素材</router-link></li>
          </ul>
        </router-link>
      </li>
      <li class="">
        <router-link class="" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact to="/products?list=1">製作事例
        </router-link>
      </li>
      <li class="">
        <router-link class="" to="/deal" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>お見積り
				</router-link>
      </li>
      <li class="">
        <router-link class="withSubMenu" to="/about" @mouseenter.native="openSubMenu" @mouseleave.native="closeSubMenu" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>会社情報
          <ul class="subMenu">
            <li class=""><router-link class="" to="/about/announcement?list=1" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive">お知らせ</router-link></li>
            <li class=""><router-link class="" to="/about/official?list=1" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive">公式文章一覧</router-link></li>
          </ul>
        </router-link>
      </li>
      <li class="">
        <router-link class="" to="/recruit" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>採用情報
        </router-link>
      </li>
      <li class="">
        <router-link class="withSubMenu" @mouseenter.native="openSubMenu" @mouseleave.native="closeSubMenu" to="/customer" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive" exact>お客様窓口
          <ul class="subMenu rightEnd">
            <li class=""><router-link class="" to="/customer/contact" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive">お問い合わせフォーム</router-link></li>
<!--
            <li class=""><router-link class="" to="/customer/faq" :class="{linkDisable:true,linkEnable:linkStatus}" active-class="pageActive">FAQ</router-link></li>
-->
          </ul>
        </router-link>
      </li>

      <li class="signOutButton" v-show="!signIn"><button @click="signOut">ログアウト</button></li>
    </ul>
  </nav>
</template>

<script>
/*
本来このメインナビゲーションは、vue-routerと連動して自動生成されるのが望ましい
routes:[]には情報が全て載っているので
*/
//import store from '../store'

export default {
  name:'mainNav',
  component:{
  },
  data: function() {
    return { 
      menuOpenClose:false,
      linkStatus:true,
    }
  },
  props: {
    navIcon:{
      type:Boolean,
    }
  },
  computed:{
    getNavIcon:function() {
      return this.navIcon
    },
    signIn:function() {
      return !this.$store.getters.idToken
    },
  },
  beforeUpdate:function() {
      this.linkStatus = true
/*
    if ( !this.$store.getters.idToken) {
      this.linkStatus = false
    } else {
      this.linkStatus = true
    }
*/
  },
  updated:function() {
  },
  methods: {
    openSubMenu:function(e) {
 if( document.body.clientWidth > 976) { /*990から修正 mediaクエリのmax-widthと不一致のため*/

      e.target.children[0].classList.add("slideYIn")
      /*親のサイズを調べて左端について開くようにサイズをcss変数に入れる*/
      document.documentElement.style.setProperty('--parentMenuWidth', parseInt(e.target.offsetWidth) + 'px')
}
    },
    closeSubMenu:function(e) {
      e.target.children[0].classList.remove("slideYIn")
    },
    openSubSubMenu:function(e) {
      e.target.children[0].classList.add("slideXIn")
    },
    closeSubSubMenu:function(e) {
      e.target.children[0].classList.remove("slideXIn")
    },
/*
    mainMenu:function() {
      let navObject = document.querySelector(".nav_main")
      if(!this.menuOpenClose) {
        navObject.classList.add("openMainMenu")
      } else {
        navObject.classList.remove("openMainMenu")
      }
      this.menuOpenClose = !this.menuOpenClose
    },
*/
    mainMenu:function() {
      let navObject = document.querySelector(".nav_bar")
      if(!this.menuOpenClose) {
        navObject.classList.add("openMainMenu")
      } else {
        navObject.classList.remove("openMainMenu")
      }
      this.menuOpenClose = !this.menuOpenClose
    },

/*Tabバーボタン対応処理*/
		focusButton:function() {
      let navObject = document.querySelector(".nav_bar")
			if(navObject.classList.contains("icon")) {
				navObject.classList.remove("icon")
			} else {
				navObject.classList.add("icon")
			}
		},

    setNav:function() {
    },
    handleScroll:function (evt, el) {
      if( document.body.clientWidth < 991) { el.classList.remove("icon"); return false }
      if(window.scrollY > 50) {
        el.classList.add("icon")
      } else {
        el.classList.remove("icon")
      }
      return false
    },
    openNavMain:function(e) {
      e.target.classList.remove("icon")
    },
    closeNavMain:function(e) {
    },
		eventStop:function(e) {
this._log("touchSTART")
/*
e.stopPropagation()
*/
		},
		eventMove:function(e) {
this._log("touchMove")
/*
e.stopPropagation()
*/
		},

    signOut:function(){
      this.$dialog
      .confirm({
        title: 'ログアウト',
        body: 'ログアウトしてもよろしいですか？'
      },{
        okText: 'はい',
        cancelText: 'キャンセル',
      })
      .then(() => {
        this.$store.commit('updateIdToken', '')
        this.$router.push('/login')
      })
      .catch(() => {
      })
    },
    setLinkActive:function() {
//将来的には、nav生成自体をRouter情報から行うようにしていく
    },
  },
}
</script> 

<style>
</style>
